import './Input.css';

interface InputProps {
  label: string;
  value: string;
  type?: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

export function Input({
  label,
  value,
  type = 'text',
  placeholder,
  onChange,
}: InputProps) {
  return (
    <div className="input-container">
      <label>{label}</label>

      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}